// src/components/Spinner.js
import React from 'react';
import './Spinner.css'; // We will create this CSS file next

// This is a simple, stateless component that just renders a div.
const Spinner = () => {
  return <div className="spinner"></div>;
};

export default Spinner;